import React from "react";
import { GenderValue } from "shared";
import { useTranslate } from "../../hooks/useTranslate";
import { useNavigation } from "../../state/navigationContext";
import { styled } from "@mui/material";
import GenderIcon from "fe-web-components/genderIcon/GenderIcon";
import { PatientColorMap } from "../../layout/patientColorMap";

//region [[ Styles ]]

const SummaryHeaderView = styled("div")(() => ({}));

const SummaryHeaderContainer = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
}));

const Text = styled("div")({
  margin: "0 8px",
  display: "flex",
  flexFlow: "column",
  "& > *": {
    margin: "3px 0",
  },
});

const AgeAndGender = styled("span")({
  fontSize: "14px",
  fontWeight: 500,
});

const Name = styled("span")({
  fontSize: "14px",
  fontWeight: 700,
  color: PatientColorMap.Primary,
});

//endregion [[ Styles ]]

//region [[ Props ]]
export interface PatientSummaryAgeAndGenderProps {
  age: string;
  gender: GenderValue;
  name?: string;
}
//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

const PatientSummaryAgeAndGender = ({
  ...props
}: PatientSummaryAgeAndGenderProps) => {
  const { age, gender } = props;
  const { translate } = useTranslate();
  const GENDER_MALE = "MALE";
  const GENDER_FEMALE = "FEMALE";

  const genderText = translate(
    gender === GenderValue.MALE ? GENDER_MALE : GENDER_FEMALE,
  );

  const ageText = age ? `, ${age}` : "";

  const { themeSettings } = useNavigation();

  return (
    <SummaryHeaderView>
      <SummaryHeaderContainer>
        <GenderIcon gender={gender} themeSettings={themeSettings} />
        <Text>
          {!!props.name && <Name>{props.name}</Name>}
          <AgeAndGender> {`${genderText}${ageText}`}</AgeAndGender>
        </Text>
      </SummaryHeaderContainer>
    </SummaryHeaderView>
  );
};

export default PatientSummaryAgeAndGender;
